import { useSelector } from "react-redux";
import { matchPath, useLocation } from "react-router"
import { selectNavigation } from "../store/slices/Navigation/selectors";

export const useTitle = () => {
  const location = useLocation();
  const paths = useSelector(selectNavigation);
  const path = paths.find((path) => matchPath(path, location.pathname));

  if (!path) return ''
  return path.label;
}
